import { gql } from '@apollo/client';

const SHARE_LINK = gql`
  query getSharePostLink($id: ID!) {
    getSharePostLink(id: $id)
  }
`;

export { SHARE_LINK };
